import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { Add } from '@material-ui/icons';
import { useFormikContext } from 'formik';

import ActionsMenu from 'components/ActionsMenu';
import { IMenuAction } from 'components/ActionsMenu/interfaces';
import { IPolicy } from 'interfaces/Policy';
import { RootState } from 'store';

import { IAddResourceButtonProps } from './interfaces';

const AddResourceButton: React.FC<IAddResourceButtonProps> = ({
  push,
}: IAddResourceButtonProps) => {
  const { resources } = useSelector((state: RootState) => state.permissionList);
  const { values } = useFormikContext<IPolicy>();

  const notAddedResources = useMemo(
    (): IMenuAction[] =>
      resources
        .filter((r) => !values.permissions.find((p) => p.resource === r._id))
        .map((r) => ({
          label: r.name,
          onClick: () =>
            push({
              resource: r._id,
              operations: [],
            }),
        })),
    [resources, values],
  );

  return notAddedResources.length ? (
    <ActionsMenu icon={Add} actionItems={notAddedResources} />
  ) : null;
};

export default AddResourceButton;
